"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HideIcon = void 0;
var React = require("react");
var IconWrapper_1 = require("../Icon/IconWrapper");
var HideIcon = function (props) { return (React.createElement(IconWrapper_1.IconWrapper, __assign({}, props),
    React.createElement("path", { fill: "currentColor", d: "M11.9999 7C8.17287 7 4.95375 9.23347 4 11.8C4.95375 14.3665 8.17287 16.6 11.9999 16.6C15.8269 16.6 19.046 14.3665 20 11.8C19.046 9.23347 15.8269 7 11.9999 7ZM11.9999 15.2476C10.1041 15.2476 8.56702 13.7039 8.56702 11.8C8.56702 9.8959 10.1041 8.35244 11.9999 8.35244C13.8961 8.35244 15.433 9.8959 15.433 11.8C15.433 13.7039 13.8961 15.2476 11.9999 15.2476ZM9.81221 11.8C9.81221 10.5866 10.7919 9.60296 11.9999 9.60296C13.2078 9.60296 14.1878 10.5866 14.1878 11.8C14.1878 13.0136 13.2078 13.9973 11.9999 13.9973C10.7919 13.9973 9.81221 13.0136 9.81221 11.8Z" }),
    React.createElement("rect", { x: "17.728", y: "4.29289", width: "2", height: "19", transform: "rotate(45 17.728 4.29289)", fill: "currentColor", stroke: "white" }))); };
exports.HideIcon = HideIcon;
